// FILE GENERATED BY IMPORT/INDEX.MJS - CHANGES WILL LIKELY BE OVERWRITTEN
/* eslint-disable react/jsx-props-no-spreading */
import * as React from 'react'

function Venue2523(props) {
    return (
        <svg
            id="Layer_1"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 250 250"
            {...props}
        >
            <defs>
                <style>
                    {
                        '\n      .st0 {\n        stroke: #b7b7b7;\n      }\n\n      .st0, .st1, .st2 {\n        fill: none;\n      }\n\n      .st3 {\n        fill: #5b5b5b;\n      }\n\n      .st4, .st5, .st6, .st7 {\n        fill: #fff;\n      }\n\n      .st4, .st2 {\n        stroke-width: .8px;\n      }\n\n      .st4, .st2, .st6, .st7 {\n        stroke: #fff;\n      }\n\n      .st1 {\n        stroke: #b3b3b3;\n        stroke-miterlimit: 3.9;\n      }\n\n      .st8, .st9, .st10 {\n        isolation: isolate;\n      }\n\n      .st11, .st9 {\n        fill: #68836a;\n      }\n\n      .st12 {\n        fill: #a88b49;\n      }\n\n      .st13 {\n        fill: #7f7f7f;\n      }\n\n      .st9 {\n        font-size: 11px;\n      }\n\n      .st9, .st10 {\n        font-family: ArialMT, Arial;\n      }\n\n      .st10 {\n        font-size: 5px;\n      }\n\n      .st6 {\n        stroke-width: .8px;\n      }\n\n      .st6, .st7 {\n        stroke-miterlimit: 4;\n      }\n\n      .st7 {\n        stroke-width: .7px;\n      }\n\n      .st14 {\n        display: none;\n      }\n    '
                    }
                </style>
            </defs>
            <g id="Layer_11">
                <g id="_x32_523_-_George_M._Steinbrenner_Field">
                    <g id="Compass_copy_4">
                        <g id="Compass">
                            <polygon
                                className="st3"
                                points="230.6 203.7 222.1 200.4 216.2 195 223.8 197.6 230.6 203.7"
                            />
                            <path
                                className="st13"
                                d="M236.4,206.9c-4.4,7.4-13.9,9.8-21.2,5.4s-9.8-13.9-5.4-21.2c4.4-7.4,13.9-9.8,21.2-5.4,7.3,4.3,9.7,13.9,5.4,21.2ZM210.8,191.8c-4,6.7-1.8,15.4,5,19.4,6.7,4,15.4,1.8,19.4-5,4-6.7,1.8-15.4-5-19.4-6.7-4-15.4-1.7-19.4,5Z"
                            />
                            <path
                                className="st3"
                                d="M241.6,210c-6.1,10.2-19.3,13.6-29.6,7.6-10.2-6.1-13.6-19.3-7.6-29.6,6.1-10.2,19.3-13.6,29.6-7.6,10.3,6.1,13.7,19.4,7.6,29.6ZM206.2,189c-5.5,9.3-2.4,21.3,6.9,26.9,9.3,5.5,21.3,2.4,26.9-6.9,5.5-9.3,2.4-21.3-6.9-26.9-9.4-5.5-21.4-2.4-26.9,6.9Z"
                            />
                            <circle className="st3" cx={223} cy={199} r={3} />
                            <path
                                className="st3"
                                d="M214.4,195.3l-2.6-1.6.2-.4h2.5c0-.1-1.8-1.2-1.8-1.2l.3-.4,2.6,1.6-.2.4h-2.6c0,.1,1.8,1.2,1.8,1.2l-.2.4Z"
                            />
                            <circle className="st5" cx={223} cy={199} r={1.6} />
                        </g>
                    </g>
                    <path
                        id="outfield"
                        className="st12"
                        d="M216.5,108.5l-1.1-1.7-1.2-2-1.1-1.9-1.2-1.9-1.5-2.2-1.6-1.7-1.6-1.9-1.7-1.6-1.7-2-1.8-1.9-1.5-1.5-1.8-1.9-1.9-2.1-1.4-1.4-2.1-2.2-1.8-2.1-1.8-1.8-1.8-1.9-1.9-1.9-1.9-1.9-1.9-1.9-1.9-2-2-2-2-2-2-2.1-2.1-2.1-2.1-2.1-2.2-2.2-2.2-2.2-2.2-2.3-2.3-1.7-2.5-1.7-2.5-1.9-2.7-2.1-2.5-1.8-2.4-1.4-3-1.1-2.7-1-2.5-.7-2.7-.8-2.7-.7-3.1-.5-3-.4-3.5-.7h-2.9c0-.1-2.7,0-2.7,0h-6.1s-3,.4-3,.4l-2.7.3-3,.5-3.6.5-1.9.7-2.8,1-2.9.9-3.6,1.3-2.7,1.5-2.5,1.6-2.1,1.2-2.9,1.7-2.5,1.5-2.4,1.6-2.3,2.1-2.2,2.2-2.2,2.2-2.1,2.1-2.1,2.1-2.1,2.1-2,2-2,2-2,2-2,2-2,2-1.9,1.9-1.9,1.9-1.9,1.9-1.9,1.9-1.9,1.9-1.9,1.9-1.7,2-1.3,2.5-1.5,2.6-1.2,2.9-.9,2.9-.8,2.5-.5,2.3-.5,3.7-.4,3.2-.6,3.4,2.2,2.5,1.9,3.4.9-.7,23.8,24.1,11.8,20,1.5-.6,1.1,2.1,8.4,14-.5.5,19.5,32.7,1.8-1s2.1,2.9,3.1,4.4,2.8,3.7,4.7,4.9c2.5,1.4,6.5,4.1,10.3,4.8s5.8.5,8.6-.3,5.9-2.7,7.8-3.9,1.9-1,2.9-1.8c1.5-1.2,2.8-3,3.4-4.3,1.7-2.5,2.7-4.2,2.7-4.2l2.8,1.9,18.7-32.9-1.4-1,9.9-16.3,1.2.7,5.6-9.7,6.9-11.5,9-9.3,17.7-17.5-.6-2-.5-.9Z"
                    />
                    <path
                        id="grass"
                        className="st11"
                        d="M49.2,120.8s-3.1-3.6-5.8-6.2-2.9-3.6-3-7.7,2.9-9.4,4.1-12.6,2.8-6.8,4.3-8.8,2.3-2.9,4.8-5.7,10.1-10,13.1-13,10.1-9.8,12.2-11.7,6.4-4.5,8.5-5.9,8.8-4.2,11.8-5.8,9.2-2.2,13.1-2.5,11.7.5,13.6.6c1.9,0,16.6,3.2,19,4.3s8.6,5.4,14.1,9.3c1.2.8,44.6,46.4,46.1,48.1s3,3.7,2.9,6.1-.4,3-1.8,4.7-10.8,10.6-13.8,13.7c-3,3.1-5.1,6.2-5.8,7.1s-5.9,7.7-10.9,15.9c-7.8,12.7-16.7,27.5-17.6,29.1-3,5.3-6.9,12.2-8.2,14s-9.9,13.5-11.2,15.1-3,3.6-4.8,5.1-5.5,3-8.6,2.9c-4.8-.1-7.7-2.7-9.1-4.1s-5.6-7-7.2-9-4.7-6.3-7-9.3-8-12.1-10.9-16.4-4.3-8.2-7.8-13.9-3.2-5.1-4.6-7.4c-2.1-3.4-3.9-6.2-5.3-7.7-3.1-3.4-7.6-10.7-8.8-12.6s-13.3-13.6-13.3-13.6l-1.9-2Z"
                    />
                    <path
                        id="infield_sand"
                        className="st12"
                        d="M163.9,166.7l-1-1c-5-16-20-27.7-37.7-27.7s-32.7,11.7-37.7,27.7l-1,1,32.7,32.7c-.5.9-.7,1.9-.7,3,0,3.7,3,6.7,6.7,6.7s6.7-3,6.7-6.7-.3-2.1-.7-3l32.7-32.7ZM122.5,154.7c.8.5,1.7.8,2.7.8s1.9-.3,2.7-.8l16.8,16.8c-1.6,1.6-1.6,4.1,0,5.6l2.5,2.5-17.7,17.7c-1.2-1-2.7-1.6-4.3-1.6s-3.2.6-4.3,1.6l-17.7-17.7,2.5-2.5c1.6-1.5,1.6-4,0-5.6l16.8-16.8Z"
                    />
                    <g className="st8">
                        <g className="st8">
                            <text
                                className="st9"
                                transform="translate(211.4 95.6)"
                            >
                                <tspan x={0} y={0}>
                                    314
                                </tspan>
                            </text>
                        </g>
                    </g>
                    <g className="st8">
                        <g className="st8">
                            <text
                                className="st9"
                                transform="translate(15.3 88.6)"
                            >
                                <tspan x={0} y={0}>
                                    318
                                </tspan>
                            </text>
                        </g>
                    </g>
                    <g className="st8">
                        <g className="st8">
                            <text
                                className="st9"
                                transform="translate(115.4 28.2)"
                            >
                                <tspan x={0} y={0}>
                                    408
                                </tspan>
                            </text>
                        </g>
                    </g>
                </g>
                <g id="persistent">
                    <g id="mound">
                        <path
                            id="pitching-mound"
                            className="st12"
                            d="M122.5,174.7c-1.5,1.5-1.5,3.9,0,5.4s3.9,1.5,5.4,0c1.5-1.5,1.5-3.9,0-5.4-1.4-1.5-3.9-1.5-5.4,0Z"
                        />
                        <path
                            id="pitching-rubber"
                            className="st4"
                            d="M123.2,176.6h4v1.6h-4v-1.6Z"
                        />
                    </g>
                    <g id="lines">
                        <path
                            id="left-foul-line"
                            className="st2"
                            d="M125.2,203.2L18.5,96.5"
                        />
                        <path
                            id="right-foul-line"
                            className="st2"
                            d="M125.2,203.2l106.7-106.8"
                        />
                    </g>
                    <g id="bases">
                        <rect
                            id="third-base"
                            className="st7"
                            x={99.2}
                            y={175.1}
                            width={3}
                            height={3}
                            transform="translate(-95.4 122.9) rotate(-45)"
                        />
                        <rect
                            id="first-base"
                            className="st7"
                            x={148.1}
                            y={175.2}
                            width={3}
                            height={3}
                            transform="translate(-81.1 157.5) rotate(-45)"
                        />
                        <rect
                            id="second-base"
                            className="st6"
                            x={123.7}
                            y={148.6}
                            width={3}
                            height={3}
                            transform="translate(-69.5 132.5) rotate(-45)"
                        />
                        <polygon
                            id="home"
                            className="st4"
                            points="126.7 201.8 125.2 203.4 123.7 201.8 123.7 200.3 126.7 200.3 126.7 201.8"
                        />
                    </g>
                </g>
                <g id="grid" className="st14">
                    <g>
                        <g id="numbers">
                            <g className="st8">
                                <text
                                    className="st10"
                                    transform="translate(91 184.1) rotate(-44.2)"
                                >
                                    <tspan x={0} y={0}>
                                        90
                                    </tspan>
                                </text>
                            </g>
                            <g className="st8">
                                <text
                                    className="st10"
                                    transform="translate(56.5 153.8) rotate(-44.2)"
                                >
                                    <tspan x={0} y={0}>
                                        200
                                    </tspan>
                                </text>
                            </g>
                            <g className="st8">
                                <text
                                    className="st10"
                                    transform="translate(71 168.4) rotate(-44.2)"
                                >
                                    <tspan x={0} y={0}>
                                        150
                                    </tspan>
                                </text>
                            </g>
                            <g className="st8">
                                <text
                                    className="st10"
                                    transform="translate(80.4 177.7) rotate(-44.2)"
                                >
                                    <tspan x={0} y={0}>
                                        120
                                    </tspan>
                                </text>
                            </g>
                            <g className="st8">
                                <text
                                    className="st10"
                                    transform="translate(41.6 139) rotate(-44.2)"
                                >
                                    <tspan x={0} y={0}>
                                        250
                                    </tspan>
                                </text>
                            </g>
                            <g className="st8">
                                <text
                                    className="st10"
                                    transform="translate(27.5 124) rotate(-44.2)"
                                >
                                    <tspan x={0} y={0}>
                                        300
                                    </tspan>
                                </text>
                            </g>
                            <g className="st8">
                                <text
                                    className="st10"
                                    transform="translate(12.7 109.2) rotate(-44.2)"
                                >
                                    <tspan x={0} y={0}>
                                        350
                                    </tspan>
                                </text>
                            </g>
                            <g className="st8">
                                <text
                                    className="st10"
                                    transform="translate(15 75.9) rotate(-44.2)"
                                >
                                    <tspan x={0} y={0}>
                                        400
                                    </tspan>
                                </text>
                            </g>
                            <g className="st8">
                                <text
                                    className="st10"
                                    transform="translate(15 49.4) rotate(-44.2)"
                                >
                                    <tspan x={0} y={0}>
                                        450
                                    </tspan>
                                </text>
                            </g>
                            <g className="st8">
                                <text
                                    className="st10"
                                    transform="translate(15 24.6) rotate(-44.2)"
                                >
                                    <tspan x={0} y={0}>
                                        500
                                    </tspan>
                                </text>
                            </g>
                        </g>
                        <g id="surface29">
                            <path className="st1" d="M125.5,203.8L-22.5,55.8" />
                            <path className="st1" d="M124.8,203.8L272.8,55.8" />
                            <path className="st0" d="M125.1,203.5L45.4,10.9" />
                            <path className="st0" d="M125.1,203.5V-4.9" />
                            <path className="st0" d="M125.1,203.5L204.9,10.9" />
                        </g>
                        <path
                            id="_x31_00-line"
                            className="st1"
                            d="M89.8,168.1c9-9.1,21.6-14.8,35.4-14.8s26.2,5.6,35.3,14.6"
                        />
                        <path
                            id="_x32_00-line"
                            className="st1"
                            d="M66.2,144.5c15.1-15.1,35.9-24.5,59-24.5s43.8,9.3,58.8,24.4"
                        />
                        <path
                            id="_x39_0-line"
                            className="st1"
                            d="M98.5,176.8c6.8-6.9,16.2-11.1,26.7-11.1s19.7,4.2,26.5,11"
                        />
                        <path
                            id="_x31_20-line"
                            className="st1"
                            d="M80.9,159.3c11.3-11.4,27-18.4,44.3-18.4s32.8,7,44.1,18.3"
                        />
                        <path
                            id="_x32_50-line"
                            className="st1"
                            d="M51.5,129.8c18.8-18.9,44.9-30.6,73.7-30.6s54.7,11.6,73.6,30.5"
                        />
                        <path
                            id="_x33_00-line"
                            className="st1"
                            d="M36.8,115.1c22.6-22.7,53.9-36.7,88.4-36.7s65.7,14,88.3,36.6"
                        />
                        <path
                            id="_x33_50-line"
                            className="st1"
                            d="M21.8,100.6c26.4-26.6,63-43.1,103.4-43.1s76.6,16.3,103,42.7"
                        />
                        <path
                            id="_x34_50-line"
                            className="st1"
                            d="M-7.4,70.9C26.5,36.9,73.4,15.9,125.2,15.9s98.6,21,132.5,54.9"
                        />
                        <path
                            id="_x34_00-line"
                            className="st1"
                            d="M7.3,85.6c30.1-30.2,71.8-48.9,117.9-48.9s87.6,18.6,117.7,48.8"
                        />
                        <path
                            id="_x35_00-line"
                            className="st1"
                            d="M-22.1,56.2C15.5,18.4,67.6-4.9,125.2-4.9s109.5,23.3,147.2,61"
                        />
                    </g>
                </g>
            </g>
        </svg>
    )
}
export default Venue2523
